import { createModule } from '../actions/utils';
import { SERVICE_ENDPOINT } from '../apis/constants';

const GET_KEYBOARD_SHORTCUTS = createModule({
  base: 'GET_KEYBOARD_SHORTCUTS', apiDetails: SERVICE_ENDPOINT.GET_KEYBOARD_SHORTCUTS,
});

const SAVE_KEYBOARD_SHORTCUTS = createModule({
  base: 'SAVE_KEYBOARD_SHORTCUTS', apiDetails: SERVICE_ENDPOINT.SAVE_KEYBOARD_SHORTCUTS,
});

export {
  GET_KEYBOARD_SHORTCUTS,
  SAVE_KEYBOARD_SHORTCUTS,
};
